const checkboxWithImage = () => {
    if(document.querySelector('.stoof-box-checkbox-holder')){
        const allHolders = document.querySelectorAll('.stoof-box-checkbox-holder');
        if(allHolders.length > 0){
            allHolders.forEach(holder =>{
                const radioList = holder.querySelector('.acf-radio-list');
                const list = holder.querySelector('.acf-checkbox-list');
                const allCheckboxes = list ? list.querySelectorAll('input[type=checkbox]') : [];
                const allRadios = radioList ? radioList.querySelectorAll('input[type=radio]') : [];
                if(allCheckboxes.length > 0){
                    allCheckboxes.forEach(box => {
                        box.addEventListener('change', ev =>{
                            box.parentElement.classList.toggle('stoof-box-active');
                        })
                    })
                }
                if(allRadios.length > 0){
                    allRadios[0].parentElement.classList.add('stoof-box-active');
                    allRadios.forEach(box => {
                        box.addEventListener('change', ev =>{
                            allRadios.forEach(radio =>{
                                radio.removeAttribute('checked');
                                //radio.setAttribute('checked', false);
                                radio.parentElement.classList.remove('stoof-box-active');
                                radio.parentElement.classList.remove('selected');
                            })
                            box.parentElement.classList.toggle('stoof-box-active');
                            box.parentElement.classList.toggle('selected');
                            box.setAttribute('checked', true);
                        })
                    })
                }
            })
        }
    }
}
export default checkboxWithImage;